const SET_INFO = 'set_info';
const SET_MERCHANTS = 'set_merchants';
const SET_BRANDS = 'set_brands';

const state = () => ({
  info: null,
  merchants: [],
  brands: [],
});

const actions = {
  fetchCardInfo ({ commit }, data) {
    return this.$api.post('/giftcard/info', {
      cardId: data.number,
      verificationCode: data.code,
    })
      .then(({ data }) => {
        commit(SET_INFO, data);
      });
  },

  fetchMerchants ({ commit, rootGetters }, { clearMarkers, geocode, moveTo }) {
    commit(SET_MERCHANTS, []); // clear data

    const searchKey = rootGetters['googleMap/getSearchKey'];
    const center = rootGetters['googleMap/getCenter'];
    const distance = rootGetters['googleMap/getDistance'];

    const params = {};
    if (searchKey) {
      params.search = searchKey;

      geocode(`${searchKey}, Nederland`).then((coords) => {
        moveTo(coords);
      });
    } else {
      if (center) {
        params.point = `${center.lat},${center.lng}`;
      }

      if (distance) {
        params.distance = distance;
      }
    }

    params.brand = this.$getEnv('BRAND_UUID');

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      this.$axios.get(`${this.$getEnv('GIFTCARD_API_URL')}/storelocator`, {
        params,
      }).then((response) => {
        let data = response.data;
        if (typeof data['hydra:member'] !== 'undefined') {
          data = data['hydra:member'];
        }

        clearMarkers();
        commit(SET_MERCHANTS, data);

        resolve(data);
      }).catch(reject);
    });
  },
  fetchBrands ({ commit }) {
    this.$axios.get(`${this.$getEnv('GIFTCARD_API_URL')}/brands`).then((response) => {
      commit(SET_BRANDS, response.data);
    });
  },
};

const mutations = {
  [SET_INFO] (state, info) {
    state.info = info;
  },
  [SET_MERCHANTS] (state, merchants) {
    state.merchants = merchants;
  },
  [SET_BRANDS] (state, brands) {
    state.brands = brands;
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
